import React, { useEffect, useState } from "react";
import {
	AntdButton,
	AntdTable,
	BodyContainer,
	Container,
	HeaderContainer,
	Section,
	StepContainer,
} from "./styles";
import { COLORS, SIZES, Typo } from "../../../../../../../layout/theme";
import { numberWithDotAndCommas } from "../../../../../../../../utils/numberWithDotAndComas";
import Image from "../../../../../../../common/image/Image";
import { FaImages } from "react-icons/fa";
import { IoIosArrowRoundBack } from "react-icons/io";
import moment from "moment";
import { CONSTANTS } from "../../../../../../../../utils/constants";
import { calculatePSLFinalDiscount } from "../../../../../../../../utils/calculatePrice";
import { Modal, Spin } from "antd";
import { BsDownload } from "react-icons/bs";
import {
	download_crm_order_detail,
	update_order_state,
} from "../../../../../../../../api/endpoints/orders";
import CustomAntdTooltip from "../../../../../../../common/custom-antd-tooltip/CustomAntdTooltip";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../../../../utils/notificationToast";

const { confirm } = Modal;

export default function Step2OrderDetail({
	stepData,
	handleBackStep,
	setOrderStateChange,
	laboratoryId,
}) {
	const [loading, setLoading] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const selectStateToShow = (state) => {
		switch (state) {
			case CONSTANTS.ORDER_STATE_PENDING:
				return "Pendiente";
			case CONSTANTS.ORDER_STATE_ACTIVE:
				return "Activa";
			case CONSTANTS.ORDER_STATE_SENDED:
				return "Enviada";
			case CONSTANTS.ORDER_STATE_CANCELED:
				return "Cancelada";
			case CONSTANTS.ORDER_STATE_PROCESSED:
				return "Procesada";
			case CONSTANTS.ORDER_STATE_BILLED:
				return "Facturada";
			case CONSTANTS.ORDER_STATE_REJECTED:
				return "Rechazada";
			case CONSTANTS.ORDER_STATE_RECEIVED:
				return "Recibida";
			case CONSTANTS.ORDER_STATE_PARTIAL_BILLED:
				return "Facturada (parcial)";

			default:
				return;
		}
	};

	const columns = [
		{
			title: (algo) => {
				return (
					<div
						style={{
							fontSize: "18px",
						}}
					>
						<FaImages style={{ color: COLORS.DarkGrey }} />
					</div>
				);
			},
			dataIndex: "productPhotoUrl",
			key: "productPhotoUrl",
			width: 80,
			align: "center",
			render: (value, record, index) => (
				<Image width={40} height={40} src={value} alt={record.productTitle} />
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Producto
				</div>
			),
			dataIndex: "productTitle",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value} {record.productComboName && `(${record.productComboName})`}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Ean
				</div>
			),
			width: 140,
			dataIndex: "productEan13",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Cantidad
				</div>
			),
			dataIndex: "quantity",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Subtotal
				</div>
			),
			dataIndex: "price",
			render: (value, record) => (
				<Typo level={7} type="muted">
					${numberWithDotAndCommas(value)}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Descuento
				</div>
			),
			dataIndex: "productDiscount",
			render: (value, record) => (
				<Typo level={7} type="muted">
					$
					{numberWithDotAndCommas(
						(parseFloat(record.price) - parseFloat(record.offerPrice)).toFixed(
							2
						)
					)}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Total
				</div>
			),
			dataIndex: "offerPrice",
			render: (value, record) => (
				<Typo level={7} type="muted">
					${numberWithDotAndCommas(value)}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					% PSL Final
				</div>
			),
			dataIndex: "discount",
			width: 110,
			render: (value, record) => (
				<Typo level={7} type="muted">
					{numberWithDotAndCommas(
						calculatePSLFinalDiscount(
							record?.offerPrice,
							record?.price,
							record?.clientGeneralDiscount
						).toFixed(2)
					)}{" "}
					%
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Facturados
				</div>
			),
			dataIndex: "productUnitsBilled",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{record.productStateInOrder ? value : ""}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Pendientes
				</div>
			),
			dataIndex: "productUnitsPending",
			render: (value, record) => (
				<Typo level={7} type={value > 0 ? "danger" : "muted"}>
					{record.productStateInOrder ? value : ""}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Estado
				</div>
			),
			dataIndex: "productStateInOrder",
			width: 140,
			render: (value, record) => (
				<Typo
					level={7}
					type={
						record?.productStateInOrder
							? record?.productStateInOrder ===
							  CONSTANTS.ORDER_ITEM_STATE_RECEIVED
								? "secondary"
								: record?.productStateInOrder ===
								  CONSTANTS.ORDER_ITEM_STATE_PROCESSED
								? "secondary"
								: record?.productStateInOrder ===
								  CONSTANTS.ORDER_ITEM_STATE_BILLED
								? "terciary"
								: record?.productStateInOrder ===
								  CONSTANTS.ORDER_ITEM_STATE_REJECTED
								? "danger"
								: record?.productStateInOrder ===
								  CONSTANTS.ORDER_ITEM_STATE_UNEXIST
								? "danger"
								: record?.productStateInOrder ===
								  CONSTANTS.ORDER_ITEM_STATE_WITHOUT_STOCK
								? "danger"
								: record?.productStateInOrder ===
								  CONSTANTS.ORDER_ITEM_STATE_ERROR
								? "danger"
								: "muted"
							: "mediumGrey"
					}
				>
					{record.productStateInOrder ? value : ""}{" "}
					{record.productStateInOrderDescription &&
						record.productStateInOrderDescription.length > 0 && (
							<CustomAntdTooltip
								placement="top"
								width="115px"
								tooltipContent={[
									{
										body: `${record.productStateInOrderDescription}`,
									},
								]}
							>
								<InfoCircleOutlined style={{ color: COLORS.Secondary }} />
							</CustomAntdTooltip>
						)}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Actualizado
				</div>
			),
			dataIndex: "productStateInOrderDate",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{record.productStateInOrder
						? moment(value).format("DD-MM-YYYY").toString()
						: ""}
				</Typo>
			),
		},
	];

	const handleDownloadFile = async () => {
		setLoading(true);
		try {
			const _orderData = [
				{
					trf: stepData?.orderNumId,
					pointOfSaleName: stepData?.pointOfSaleName,
					pointOfSaleAddress: stepData?.pointOfSaleAddress,
					distributorName: stepData?.distributorName,
					orderDate: moment(stepData?.orderDate)
						.format("DD-MM-YYYY")
						.toString(),
					orderQtyItems: stepData?.orderQtyItems,
					orderQtyUnits: stepData?.orderQtyUnits,
					orderSubtotal: stepData?.orderSubtotal,
					orderTotal: stepData?.orderTotal,
					orderDiscount: stepData?.orderDiscount,
					orderProvince: stepData?.orderProvince,
					orderLocality: stepData?.orderLocality,
					orderState: stepData?.orderState,
					orderSubState: stepData?.orderSubState,
					orderQtyUnitsRejected: stepData?.qtyUnitsRejected,
					orderQtyItemsRejected: stepData?.qtyItemsRejected,
					orderSellerFirstName: stepData?.sellerFirstName,
					orderSellerLastName: stepData?.sellerLastName,
				},
			];

			const _orderProducts = stepData?.productList?.map((p) => ({
				productTitle: p.productTitle,
				productEan13: p.productEan13,
				quantity: p.quantity,
				price: p.price,
				offerPrice: p.offerPrice,
				finalDiscount: calculatePSLFinalDiscount(
					p.offerPrice,
					p.price,
					p.clientGeneralDiscount
				).toFixed(2),
				productUnitsBilled: p?.productUnitsBilled,
				productUnitsPending: p?.productUnitsPending,
				productStateInOrder: p?.productStateInOrder,
				productStateInOrderDate: p?.productStateInOrderDate,
			}));

			const res = await download_crm_order_detail({
				laboratoryId: laboratoryId,
				distributorId: "",
				pharmacyId: "",
				sellerId: "",
				chainId: "",
				orderId: stepData.orderId,
				dateFrom: "",
				dateTo: "",
			});
			const href = URL.createObjectURL(res);

			const link = document.createElement("a");
			link.href = href;

			const _fileName =
				"Ficha_Orden_" +
				stepData?.orderNumId +
				"_" +
				moment().format("DD-MM-YYYY") +
				".xlsx";
			link.setAttribute("download", _fileName);
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	const handleCancelOrder = () => {
		confirm({
			title: `¿Seguro que quiere cancelar esta orden?`,
			icon: <InfoCircleOutlined style={{ color: COLORS.Danger }} />,
			content: "El pedido será anulado",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				cancelOrderAction();
			},
		});
	};

	const cancelOrderAction = async () => {
		try {
			setSubmitting(true);
			const _state = {
				id: stepData.orderId,
				state: CONSTANTS.ORDER_STATE_CANCELED,
			};
			await update_order_state(stepData.orderId, _state);
			handleBackStep(1);
			setOrderStateChange((prev) => !prev);
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(TYPE.ERROR, "Error");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<StepContainer>
			<HeaderContainer>
				<Section
					style={{ justifyContent: "start", gap: 90, padding: "0 10px" }}
				>
					<Container style={{ width: "100%", flex: "1 1 5%" }}>
						<Section
							onClick={() => handleBackStep(1)}
							style={{ cursor: "pointer", justifyContent: "start" }}
						>
							<IoIosArrowRoundBack size={19} color={COLORS.Secondary} />
							<Typo type="secondary" level={7}>
								Volver
							</Typo>
						</Section>
					</Container>
					<Container style={{ width: "100%", flex: "1 1 25%" }}>
						<Section>
							<Typo type="grey" level={7}>
								# TRF:
							</Typo>
							<Typo type="grey" level={7}>
								{stepData?.orderNumId}
							</Typo>
						</Section>
						<Section>
							<Typo type="grey" level={7}>
								Fecha orden:
							</Typo>
							<Typo type="mediumGrey" level={7}>
								{moment(stepData?.orderDate).format("DD-MM-YYYY")}
							</Typo>
						</Section>
					</Container>
					<Container style={{ width: "100%", flex: "1 1 40%" }}>
						<Section>
							<Typo type="grey" level={7}>
								Punto de venta:
							</Typo>
							<Typo type="mediumGrey" level={7}>
								{stepData?.pointOfSaleName}
							</Typo>
						</Section>
						<Section>
							<Typo type="grey" level={7}>
								Dirección entrega:
							</Typo>
							<Typo type="mediumGrey" level={7}>
								{stepData?.pointOfSaleAddress}
							</Typo>
						</Section>
					</Container>
					<Container style={{ width: "100%", flex: "1 1 25%" }}>
						<Section>
							<Typo type="grey" level={7}>
								Droguería:
							</Typo>
							<Typo type="mediumGrey" level={7}>
								{stepData?.distributorName}
							</Typo>
						</Section>
						<Section>
							<Typo type="grey" level={7}>
								Estado:
							</Typo>
							<Typo
								type={
									stepData?.orderSubState
										? stepData?.orderSubState === CONSTANTS.ORDER_STATE_RECEIVED
											? "secondary"
											: stepData?.orderSubState ===
											  CONSTANTS.ORDER_STATE_PROCESSED
											? "secondary"
											: stepData?.orderSubState ===
											  CONSTANTS.ORDER_STATE_PARTIAL_BILLED
											? "primary"
											: stepData?.orderSubState === CONSTANTS.ORDER_STATE_BILLED
											? "terciary"
											: stepData?.orderSubState ===
											  CONSTANTS.ORDER_STATE_REJECTED
											? "danger"
											: "muted"
										: "mediumGrey"
								}
								level={7}
							>
								{stepData?.orderSubState
									? selectStateToShow(stepData?.orderSubState)
									: selectStateToShow(stepData?.orderState)}
							</Typo>
							{(stepData?.orderState === CONSTANTS.ORDER_STATE_ACTIVE ||
								stepData?.orderState === CONSTANTS.ORDER_STATE_PENDING) && (
								<AntdButton
									loading={submitting || loading}
									onClick={handleCancelOrder}
								>
									Cancelar TRF
								</AntdButton>
							)}
						</Section>
					</Container>
					<Container style={{ width: "100%", flex: "1 1 5%" }}>
						<Section>
							{loading ? (
								<Spin size="small" />
							) : (
								<CustomAntdTooltip
									placement="left"
									width="105px"
									tooltipContent={[
										{
											body: "Exportar datos",
										},
									]}
								>
									<BsDownload
										size={18}
										color={COLORS.Secondary}
										style={{ cursor: "pointer" }}
										onClick={handleDownloadFile}
									/>
								</CustomAntdTooltip>
							)}
						</Section>
					</Container>
				</Section>
			</HeaderContainer>
			<BodyContainer>
				<AntdTable
					dataSource={stepData?.productList || []}
					loading={!stepData}
					columns={columns}
					pagination={false}
					scroll={{ y: "1020px" }}
				/>
			</BodyContainer>
		</StepContainer>
	);
}
